import { useAppContext } from 'hooks/context/useAppContext';

export const useThirdPartyFormUrl = (
  guid: string | undefined,
  source: string | undefined,
) => {
  const { config, publicUser } = useAppContext();

  if (!guid) {
    return '';
  }

  const { preferences } = publicUser;
  const { apiUrlV3 } = config;

  return preferences.require_form_completion && preferences.form_url && source
    ? `${apiUrlV3}/appointments/${guid}/third_party_form?utm_source=${source}`
    : null;
};
